<template>
  <v-container fluid>
    <v-layout justify-center align-start v-if="!data._id" class="printNone">
      <v-flex xl2 md4 sm6 xs12>
        <v-card class="br-10 pa-4 text-center">
            <div class="title pa-3">{{ $t('no_account_selected') }}</div>
            <v-layout row wrap pt-2 justify-center>
              <v-btn :block="$vuetify.breakpoint.xsOnly" color="primary" class="white--text" type="button" @click="$router.push('/'); resetData()">{{ $t('go_to_homepage') }}</v-btn>
            </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-list two-line class="br-10" dense v-if="data._id">
      <v-subheader><h3>{{ $t('complaint_info') }}</h3></v-subheader>
      <v-divider></v-divider>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-bookmark fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data._id }}</v-list-item-title>
          <v-list-item-subtitle class="body-2" style="font-weight: bold;">{{ $t('complaint_no') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-calendar fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.date | dateTime }}</v-list-item-title>
          <v-list-item-subtitle class="body-2" style="font-weight: bold;">{{ $t('date') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="data.council !== 'mdkgu'">
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-list-ul fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ $t(data.category) }}</v-list-item-title>
          <v-list-item-subtitle class="body-2" style="font-weight: bold;">{{ $t('category') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="data.council === 'mdkgu'">
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-list-ul fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.subject }}</v-list-item-title>
          <v-list-item-subtitle class="body-2" style="font-weight: bold;">{{ $t('subject') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-stack-exchange fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.description | capitalize }}</v-list-item-title>
          <v-list-item-subtitle class="body-2" style="font-weight: bold;">{{ $t('description') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-map-pin fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.location | capitalize }}</v-list-item-title>
          <v-list-item-subtitle class="body-2" style="font-weight: bold;">{{ $t('location') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-headphones fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.channel | capitalize }}</v-list-item-title>
          <v-list-item-subtitle class="body-2" style="font-weight: bold;">{{ $t('channel') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-info-circle fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ $t(data.status) }}</v-list-item-title>
          <v-list-item-subtitle class="body-2" style="font-weight: bold;">{{ $t('status') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <div v-if="data.remark">
        <v-list-item>
         <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-comment fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-subtitle class="body-2" style="font-weight: bold;">{{ $t('remark') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-for="(item, index) in data.remark" :key="index">
        <v-list-item>
           <v-list-item-action>

        </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="body-2"  style="font-weight: bold;"> {{ item.datetime | dateTime }}: </v-list-item-title>
            <v-list-item-subtitle><h4>{{ item.content }}</h4></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list-item>
      </div>
    </v-list>
    <br>
    <v-list two-line class="br-10" dense v-if="data._id">
      <v-subheader><h3>{{ $t('complainant_info') }}</h3></v-subheader>
      <v-divider></v-divider>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-user-circle fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.complainant.full_name }}</v-list-item-title>
          <v-list-item-subtitle class="body-2" style="font-weight: bold;">{{ $t('name') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-id-card fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.complainant.ic_num }}</v-list-item-title>
          <v-list-item-subtitle class="body-2" style="font-weight: bold;">{{ $t('ic_num') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-phone fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.complainant.phone }}</v-list-item-title>
          <v-list-item-subtitle class="body-2" style="font-weight: bold;">{{ $t('phone') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-at fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.complainant.email }}</v-list-item-title>
          <v-list-item-subtitle class="body-2" style="font-weight: bold;">{{ $t('email') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <br>
    <v-list two-line class="br-10" dense v-if="data._id && data.geolocation">
      <v-subheader><h3>{{ $t('location') }}</h3></v-subheader>
      <v-divider></v-divider>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-map-pin fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold body-2">{{ data.location | capitalize }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('location') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="grey-text text--lighten-1" v-if="data.geolocation.coords.latitude && data.geolocation.coords.longitude"></v-divider>
      <l-map
        v-if="data.geolocation.coords.latitude && data.geolocation.coords.longitude"
        style="z-index: 0; height: 30vh"
        :zoom="17"
        :center="[ data.geolocation.coords.latitude, data.geolocation.coords.longitude ]"
        :options="{ scrollWheelZoom: false, dragging: false, closeOnClick: false, doubleClickZoom: false }">
        <l-tile-layer :url="urlMap"></l-tile-layer>
        <l-marker
          :lat-lng="[ data.geolocation.coords.latitude, data.geolocation.coords.longitude ]"
          @add="$nextTick(() => $event.target.openPopup())">
          <l-popup :options="{ closeButton: false, closeOnClick: false }">Complaint was recorded here!</l-popup>
        </l-marker>
      </l-map>
    </v-list>
    <v-card class="elevation-0 br-10" :key="name" :href="attachment.url" :download="name" v-for="(attachment, name) in data._attachments">
      <v-list two-line class="br-10 text-center" dense>
        <v-subheader><h3>{{ $t('attachment') }}</h3></v-subheader>
        <v-divider></v-divider>
        <div class="d-flex justify-center align-center">
          <v-img contain :src="data.attachmentUrl + data._id + '/' + name" max-height="300px" max-width="300px" v-if="attachment.content_type.split('/')[0] === 'image'"/>
        </div>
        <v-list-item>
          <v-list-item-action>
            <v-icon>fa-paperclip fa-lg</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">{{ name }}</v-list-item-title>
            <v-list-item-subtitle>{{ attachment.length | fileSize }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
    <v-dialog max-width="80%" :value="feedbackDialog" persistent>
      <rating-card v-if="data._id" :id="data._id" @hide="feedbackDialog = false" />
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios'
import configuration from '../../configurations'
import vuex from 'vuex'
import { LMap, LTileLayer, LMarker, LPopup } from 'vue2-leaflet'
import QrcodeVue from 'qrcode.vue'
import RatingCard from '../RatingCard'

export default {
  async beforeMount () {
    await this.fetchData({ id: this.$route.params.id })
    if (this.$route.query.feedback === 'true') {
      const { data: response } = await axios.get(`${configuration.WORKER}/rating/reference_number/${this.$route.params.id}?type=e-services`)
      if (response.rows.length === 0 || response.rows[0].value === 0) {
        this.feedbackDialog = true
      }
    }
  },
  components: {
    RatingCard,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    QrcodeVue
  },
  computed: {
    ...vuex.mapState({
      data: state => state.complaint.data,
      username: state => state.auth.username
    })
  },
  data () {
    return {
      feedbackDialog: false,
      url: configuration.host.eservices + '/' + window.location.hash,
      urlMap: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
      zoom: 16
    }
  },
  methods: {
    ...vuex.mapActions({
      fetchData: 'complaint/fetchData'
    })
  }
}
</script>
